export function handleBlogPostClick() {
    const blogList = document.querySelector('.visual-blog-list');
    if (!blogList) {
        return;
    }
    let blogItems = blogList.querySelectorAll('.elementor-post');
    blogItems.forEach(blogItem => {
        let postLink = blogItem.querySelector('.elementor-post__title a') as HTMLElement;
        if (!postLink) {
            postLink = blogItem.querySelector('.elementor-post__thumbnail__link') as HTMLElement;
        }
        if (!postLink) {
            return;
        }
        blogItem.addEventListener('click', e => {
            let target = e.target as HTMLElement;
            postLink.click();
        })
    })
}

export function handleInsightBackBtn() {
    const insightBackBtn = document.querySelector('.visual-js-back') as HTMLElement;
    if (!insightBackBtn) {
        return;
    }
    insightBackBtn.addEventListener('click', e => {
        e.preventDefault();
        window.history.back();
    })
}